module.exports = [
  {
    path: "/shopCart",
    component: () => import("../../components/shopCart/shopCart.vue"),
    name: "购物车",
    meta: {
      requireAuth: true, //要权限
    },
  },
  {
    path: "/shopWHCart",
    component: () => import("../../components/shopCart/shopWHCart.vue"),
    name: "供应商购物车",
    meta: {
      requireAuth: true, //要权限
    },
  },
];
